import { useTranslation } from 'next-i18next'

import { days } from '~/components/Calendar/constants'

export default function CalendarWeekdays(): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <div className="my-2 grid grid-cols-7 gap-1 2xl:gap-2 text-purple">
      {days.map((day) => (
        <span className="text-center text-xxs font-semibold" key={day}>
          {t(`daysShort.${day}`)}
        </span>
      ))}
    </div>
  )
}
